import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: null,
    remoteConfig: null,
    currentTheme: null
  },

  getters: {
    isSignedIn: state => !!state.currentUser,
    hasRole: state => role => state.currentUser && state.currentUser.roles.includes(role),

    remoteConfig: state => state.remoteConfig

  },

  mutations: {
    setCurrentUser(state, currentUser) {
      if (currentUser && currentUser.roles) {
        currentUser.roles.push('user')
      }
      state.currentUser = currentUser
    },

    removeCurrentUser(state) {
      state.currentUser = null
    },

    setRemoteConfig(state, config) {
      state.remoteConfig = config
    },

    removeRemoteConfig(state) {
      state.remoteConfig = null
    },

    setCurrentTheme(state, currentTheme) {
      state.currentTheme = currentTheme
    },
    removeCurrentTheme(state) {
      state.currentTheme = null
    }
  }
})

export default store
